// src/views/stats.ts
import type { GameRecord } from '../types';
import { profile } from '../core/profile';

type StatsOpts = {
  rec: GameRecord;
  onBack: () => void;
};

export function renderStats(root: HTMLElement, opts: StatsOpts): void {
  const r = opts.rec;
  const avg = r.gamesPlayed > 0 ? Math.round(r.scoreSum / r.gamesPlayed) : 0;
  const p = profile(r.channelErrSum, r.channelErrCount);

  const profileBlock = p
    ? `
      <h2>Perception profile</h2>
      <p class="subtitle">Across ${r.gamesPlayed} games. Lower is better.</p>
      <ul style="font-family: var(--mono); font-size: 14px; line-height: 1.8;">
        <li>Hue error: ${p.meanHue.toFixed(1)}°</li>
        <li>Saturation error: ${p.meanSat.toFixed(1)}%</li>
        <li>Lightness error: ${p.meanLight.toFixed(1)}%</li>
      </ul>
      <p>Strongest channel: <strong>${p.strongest}</strong>. Weakest channel: <strong>${p.weakest}</strong>.</p>
    `
    : '<p class="subtitle">Play your first game to see your perception profile.</p>';

  root.innerHTML = `
    <header class="app-header">
      <span class="brand">Barve</span>
      <span>Stats</span>
    </header>
    <div class="card">
      <h2>Streak</h2>
      <ul style="font-family: var(--mono); font-size: 14px; line-height: 1.8;">
        <li>Current streak: <strong>${r.currentStreak}</strong></li>
        <li>Max streak: <strong>${r.maxStreak}</strong></li>
        <li>Games played: <strong>${r.gamesPlayed}</strong></li>
        <li>Average score: <strong>${avg}/100</strong></li>
      </ul>
      ${profileBlock}
      <button class="secondary" id="back" style="margin-top: 24px">Back</button>
    </div>
  `;
  root.querySelector('#back')!.addEventListener('click', opts.onBack);
}
